import * as Accordion from "@radix-ui/react-accordion";
import { ComponentProps, forwardRef } from "react";
import { Content } from "./Content/content";
import { Header } from "./Header/header";
import { Item } from "./Item/item";

const Root = forwardRef<HTMLDivElement, ComponentProps<typeof Accordion.Root>>(
  ({ children, ...props }, ref) => (
    <Accordion.Root ref={ref} {...props}>
      {children}
    </Accordion.Root>
  )
);

Root.displayName = "CustomTriggerAccordionGroup";

export const CustomTriggerAccordionGroup = {
  Root,
  Content,
  Item,
  Header,
  Trigger: Accordion.Trigger,
};
